<template>
    <div
        class="ms-0 ms-md-3 mt-2 d-flex gap-2 flex-wrap"
        v-if="ActivePinnedViews && ActivePinnedViews.size > 0"
    >
        <span
            class="badge px-3 py-1 m-0"
            v-for="(view, i) in computedViews"
            :key="i"
            :style="{ 'background-color': view.color ?? colorMap[getColorIndex(i)] }"
        >
            <span class="d-flex gap-3">
                <ButtonComp
                    class="btn-sm p-0 m-0 text-white"
                    button-type="Custom"
                    :icon="view.icon"
                    @click="NavigateToView(view)"
                    >{{ $tm(view.name) }}</ButtonComp
                >

                <ButtonComp
                    button-type="Custom"
                    class="btn-sm p-0 m-0 text-white"
                    icon="fa-xmark-circle"
                    @click="UnpinView(view)"
                ></ButtonComp>
            </span>
        </span>
    </div>
</template>
<script setup lang="ts">
import { usePinnedViews, usePinnedViewsRef } from '@/composeables';
import { colorMap } from '@/utilities/colorUtils';
import { computed } from 'vue';
import { ButtonComp } from '@/components';
import { PinnedViewParams } from '@/composeables/pinnedviews/PinnedViewParams';
import { Router } from '@/objects/Router';

const { UnpinView } = usePinnedViews();
const { ActivePinnedViews } = usePinnedViewsRef();

const computedViews = computed(() => {
    return ActivePinnedViews.value.values();
});

/**
 * Get a unique color index
 * @param index
 */
const getColorIndex = (index: number) => {
    if (index >= colorMap.length) {
        return index % colorMap.length;
    }
    return index;
};

/**
 * Navigate to the view
 * @param view
 */
const NavigateToView = (view: PinnedViewParams) => {
    Router.NavigateTo(view.routeParams ?? {}, view.routeName);
};
</script>
